var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _activeFetch, _ShippingEstimator_instances, getShippingRatesBasic_fn, showResult_fn;
import { C as Component } from "./component-cLJ9vlHA.js";
import { f as fetchConfig, n as formatMoney } from "./utilities-2Suih3Nm.js";
import "./critical-Da0Dmhh9.js";
class ShippingEstimator extends Component {
  constructor() {
    super();
    __privateAdd(this, _ShippingEstimator_instances);
    __privateAdd(this, _activeFetch, null);
  }
  connectedCallback() {
    super.connectedCallback();
  }
  async calculateShipping(event) {
    if (!(event.target instanceof HTMLElement)) return;
    event.preventDefault();
    const { countrySelector, zipInput } = this.refs;
    if (!countrySelector || !zipInput) return;
    const { countrySelect, provinceSelect } = countrySelector;
    const zip = zipInput.value;
    const country = countrySelect.value;
    const province = provinceSelect.value;
    const result = await __privateMethod(this, _ShippingEstimator_instances, getShippingRatesBasic_fn).call(this, { country, province, zip });
    __privateMethod(this, _ShippingEstimator_instances, showResult_fn).call(this, result);
  }
}
_activeFetch = new WeakMap();
_ShippingEstimator_instances = new WeakSet();
getShippingRatesBasic_fn = async function({ country, province, zip }) {
  const { button } = this.refs;
  if (__privateGet(this, _activeFetch)) {
    __privateGet(this, _activeFetch).abort();
  }
  const abortController = new AbortController();
  __privateSet(this, _activeFetch, abortController);
  button.setAttribute("loading", "");
  const payload = {
    shipping_address: {
      country,
      province,
      zip
    }
  };
  try {
    const config = fetchConfig("json", {
      body: JSON.stringify(payload)
    });
    const res = await fetch(Theme.routes.shipping_rates, {
      ...config,
      signal: abortController.signal
    });
    if (!res.ok && res.status !== 422) throw new Error(`Shipping rates request failed with status ${res.status}`);
    const result = {
      status: res.ok ? "SUCCESS" : "FAILED",
      data: await res.json()
    };
    return result;
  } catch (error) {
  } finally {
    __privateSet(this, _activeFetch, null);
    button.removeAttribute("loading", "");
  }
};
showResult_fn = function(result) {
  if (!result.status) return;
  let string = ``;
  if (result.status === "SUCCESS") {
    if (result.data.shipping_rates.length > 0) {
      result.data.shipping_rates.forEach((rate) => {
        string += `<span class="estimate-result estimate-result--success">${rate.name}: ${formatMoney(rate.price, Theme.money_format)}</span>`;
      });
    } else {
      string += `<span class="estimate-result estimate-result--failed">${this.dataset.error}</span>`;
    }
  }
  if (result.status === "FAILED" && result.data) {
    Object.keys(result.data).forEach((key) => {
      if (Array.isArray(result.data[key])) {
        string += `<span class="estimate-result estimate-result--failed">${result.data[key][0]}</span>`;
      }
    });
  }
  this.refs.result.innerHTML = string;
  this.refs.result.removeAttribute("hidden");
};
if (!customElements.get("shipping-estimator")) {
  customElements.define("shipping-estimator", ShippingEstimator);
}
